import { useState } from "react";
import { ImgWrapper, StyledImg } from "./Image.style";
import LoadingCM from "components/shared/Loading";
import { IMG_BASE_URL } from "constants";

export default function ImgContainer(props) {
  const [imgLoading, setImgLoading] = useState(true);
  return (
    <ImgWrapper width={props.width} height={props.height} {...props}>
      {imgLoading && <LoadingCM isImg />}
      <StyledImg
        src={props.isWeb ? IMG_BASE_URL + props.src : props.src}
        alt={props.alt}
        onLoad={() => setImgLoading(false)}
        isShown={!imgLoading}
        objectFit={props.objectFit}
      />
    </ImgWrapper>
  );
}
